import HttpRequest from './http_request'

class GenericProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_CENTRAL_API_URL)
  }

  // Faculty
  async getFaculty() {
    const { data } = await this.get('faculty/', {
      function: 'get-faculty',
    })
    return data
  }

  async getRegistrarFaculty() {
    const { data } = await this.get('faculty/', {
      function: 'get-registrar-faculty',
    })
    return data
  }

  async getAllRegistrarDepartment() {
    const { data } = await this.get('department/', {
      function: 'get-registrar-department',
    })
    return data
  }

  async getAllRegistrarBranch() {
    const { data } = await this.get('branch/', {
      function: 'get-registrar-branch',
    })
    return data
  }

  // Curriculum
  async getCurriculum({ LEVEL_ID, FACULTY_ID, CURRICULUM_ID }) {
    const { data } = await this.get('curriculum/', {
      function: 'get-curriculum',
      LEVEL_ID,
      FACULTY_ID,
      CURRICULUM_ID,
    })
    return data
  }

  async getRegistrarCurriculum(level_id, faculty_id, curriculum_id, department_id) {
    const { data } = await this.get('curriculum/', {
      function: 'get-registrar-curriculum',
      level_id,
      faculty_id,
      curriculum_id,
      department_id,
    })
    return data
  }

  async getRegistrarCurriculumByObject({ level_id, faculty_id, curriculum_id, department_id }) {
    const { data } = await this.get('curriculum/', {
      function: 'get-registrar-curriculum',
      level_id,
      faculty_id,
      curriculum_id,
      department_id,
    })
    return data
  }

  async getAllRegistrarBachelorCurriculum() {
    const { data } = await this.get('curriculum/', {
      function: 'get-registrar-curriculum',
      level_id: '1',
    })
    return data
  }

  // Subject
  async getRegistrarSubject(level_id, subject_id) {
    const { data } = await this.get('subject/', {
      function: 'get-registrar-subject',
      level_id,
      subject_id,
    })
    return data
  }

  // Building
  async getRegistrarBuilding() {
    const { data } = await this.get('building/', {
      function: 'get-registrar-building',
    })
    return data
  }

  // Room
  async getRegistrarRoom(building_no) {
    const { data } = await this.get('building/', {
      function: 'get-registrar-room',
      building_no,
    })
    return data
  }
}

export default GenericProvider
